import { Calendar, FileMinus, Package, Twitch, User } from "lucide-react";
import { ReactNode } from "react";

import { AC_ENUM } from "../activity.constants";
import { PR_ENUM } from "../project-register.constant";

import { ROUTES } from "./routes-constant";

import { Permissions } from "@/interfaces/globals";
import Icons from "@/utils/Icons";

export interface TSidebarItem {
  icon?: ReactNode;
  text: string;
  value?: string;
  alterValue?: string;
  alert?: ReactNode;
  hasChild?: boolean;
  action?: () => void;
  children?: TSidebarItem[];
  active?: boolean;
  permission: Permissions[];
}

export const adminSidebarData: TSidebarItem[] = [
  {
    icon: <Icons size={20} name='workspace' />,
    text: "Workspaces",
    value: "/",
    alterValue: "/table",
    hasChild: false,
    permission: [],
  },

  {
    icon: <Icons size={20} name='workforce' />,
    text: "Workforce",
    value: `${ROUTES.WORKFORCE}`,
    hasChild: true,
    children: [
      {
        text: "Admin",
        active: false,
        value: `${ROUTES.ADMIN}`,
        permission: [],
      },
      {
        text: "Manager",
        active: false,
        value: `${ROUTES.MANAGER}`,
        permission: [],
      },
      {
        text: "Employee",
        active: false,
        value: `${ROUTES.EMPLOYEE}`,
        permission: [],
      },
      {
        text: "Sub-Contractor",
        active: false,
        value: `${ROUTES.SUB_CONTRACTOR}`,
        permission: [],
      },
    ],
    permission: [],
  },

  {
    icon: <User size={20} strokeWidth={1.5} />,
    text: "Customers",
    value: `${ROUTES.CUSTOMERS}`,
    alert: true,
    hasChild: false,
    permission: [],
  },
];

export const businessSidebarData: TSidebarItem[] = [
  // {
  //   icon: <Icons size={20} name='dashboard' />,
  //   text: "Dashboard",
  //   value: "/",
  //   hasChild: false,
  //   permission: [Permissions.ALL],
  // },
  {
    icon: <Icons size={20} name='roaster-icon' />,
    text: "Roster",
    value: "/",
    hasChild: false,
    permission: [Permissions.ROSTER],
  },
  {
    icon: <Icons size={20} name='suitcase' />,
    text: PR_ENUM.PROJECT_REGISTER,
    value: `${ROUTES.PROJECT_REGISTER}`,
    alert: false,
    hasChild: false,
    permission: [Permissions.PROJECT_REGISTER],
  },
  {
    icon: <Icons size={20} name='bell' />,
    text: AC_ENUM.ACTIVITY,
    value: `${ROUTES.ACTIVITY}`,
    alert: false,
    hasChild: false,
    permission: [Permissions.ACTIVITY],
  },
  {
    icon: <Icons size={20} name='estimate' />,
    text: "Estimates",
    value: `${ROUTES.ESTIMATES}`,
    active: false,
    hasChild: false,
    permission: [Permissions.ESTIMATES],
  },
  {
    icon: <Icons size={20} name='projects' />,
    text: "Projects",
    value: `${ROUTES.PROJECTS}`,
    hasChild: false,
    permission: [Permissions.PROJECTS],
  },
  {
    icon: <Icons size={20} name='projects' />,
    text: "Task & Claims",
    value: `${ROUTES.TASK_CLAIMS}`,
    hasChild: false,
    permission: [Permissions.CLAIMS],
  },
  {
    icon: <Icons size={20} name='workforce' />,
    text: "Workforce",
    value: `${ROUTES.WORKFORCE}`,
    hasChild: true,
    permission: [
      Permissions.WORKFORCE,
      Permissions.WORKFORCE_ADMIN,
      Permissions.WORKFORCE_EMPLOYEE,
      Permissions.WORKFORCE_MANAGER,
      Permissions.WORKFORCE_SUBCONTRACTOR,
      Permissions.WORKFORCE_SETTINGS,
    ],
    children: [
      {
        text: "Admin",
        active: false,
        value: `${ROUTES.ADMIN}`,
        permission: [Permissions.WORKFORCE_ADMIN],
      },
      {
        text: "Manager",
        active: false,
        value: `${ROUTES.MANAGER}`,
        permission: [Permissions.WORKFORCE_MANAGER],
      },
      {
        text: "Employee",
        active: false,
        value: `${ROUTES.EMPLOYEE}`,
        permission: [Permissions.WORKFORCE_EMPLOYEE],
      },
      {
        text: "Sub-Contractor",
        active: false,
        value: `${ROUTES.SUB_CONTRACTOR}`,
        permission: [Permissions.WORKFORCE_SUBCONTRACTOR],
      },
      {
        text: "Settings",
        active: false,
        value: `${ROUTES.WORKFORCE_SETTINGS}`,
        permission: [Permissions.WORKFORCE_SETTINGS],
      },
    ],
  },

  {
    icon: <User size={20} />,
    text: "Clients",
    value: `${ROUTES.CUSTOMERS}`,
    hasChild: true,
    permission: [
      Permissions.CUSTOMER,
      Permissions.CUSTOMER_CUSTOMER,
      Permissions.CUSTOMER_PROSPECT,
    ],
    children: [
      {
        text: "Customer",
        active: false,
        value: `${ROUTES.CUSTOMER}`,
        permission: [Permissions.CUSTOMER_CUSTOMER],
      },
      {
        text: "Prospect",
        active: false,
        value: `${ROUTES.PROSPECT}`,
        permission: [Permissions.CUSTOMER_PROSPECT],
      },
    ],
  },
  {
    icon: <Icons size={20} name='template' />,
    text: "Invoicing",
    value: `${ROUTES.INVOICING}`,
    hasChild: true,
    permission: [
      Permissions.INVOICE,
      Permissions.INVOICE_CONTRACT,
      Permissions.INVOICE_DOCKET,
    ],
    children: [
      {
        text: "Contract Invoice",
        active: false,
        value: `${ROUTES.CONTRACT_INVOICE}`,
        permission: [Permissions.INVOICE_CONTRACT],
      },
      {
        text: "Docket Invoice",
        active: false,
        value: `${ROUTES.DOCKET_INVOICE}`,
        permission: [Permissions.REPORTS],
      },
      {
        text: "Xero Invoice",
        active: false,
        value: `${ROUTES.XERO_INVOICE}`,
        permission: [Permissions.INVOICE],
      },
    ],
  },
  {
    icon: <Icons size={20} name='waste-manage' />,
    text: "Waste Manage",
    value: `${ROUTES.WASTE}`,
    hasChild: true,
    permission: [
      Permissions.WASTEMANAGE,
      Permissions.WASTEMANAGE_SUMMARY,
      Permissions.WASTEMANAGE_WEIGHTSCALE,
      Permissions.WASTEMANAGE_WEIGHTINGREPORTS,
      Permissions.WASTEMANAGE_VEHICLES,
      Permissions.WASTEMANAGE_LOADTYPE,
      Permissions.WASTEMANAGE_WASTETYPE,
      Permissions.WASTEMANAGE_DAILYREPORTS,
      Permissions.WASTEMANAGE_SETTINGS,
    ],
    children: [
      {
        text: "Summary",
        active: false,
        value: `${ROUTES.SUMMARY}`,
        permission: [Permissions.WASTEMANAGE_SUMMARY],
      },
      {
        text: "Weigh Bridge",
        active: false,
        value: `${ROUTES.WEIGH_BRIDGE}`,

        permission: [Permissions.WASTEMANAGE_WEIGHBRIDGE],
      },
      {
        text: "Weigh Scale",
        active: false,
        value: `${ROUTES.WEIGHT_SCALE}`,
        permission: [Permissions.WASTEMANAGE_WEIGHTSCALE],
      },
      {
        text: "Weighting Reports",
        active: false,
        value: `${ROUTES.WEIGHTING_REPORTS}`,
        permission: [Permissions.WASTEMANAGE_WEIGHTINGREPORTS],
      },
      {
        text: "Vehicles",
        active: false,
        value: `${ROUTES.VEHICLES}`,
        permission: [Permissions.WASTEMANAGE_VEHICLES],
      },
      {
        text: "Load Type",
        active: false,
        value: `${ROUTES.LOAD_TYPE}`,
        permission: [Permissions.WASTEMANAGE_LOADTYPE],
      },
      {
        text: "Waste Type",
        active: false,
        value: `${ROUTES.WASTE_TYPE}`,
        permission: [Permissions.WASTEMANAGE_WASTETYPE],
      },
      {
        text: "Daily Reports",
        active: false,
        value: `${ROUTES.DAILY_REPORTS}`,
        permission: [Permissions.WASTEMANAGE_DAILYREPORTS],
      },
      {
        text: "Settings",
        active: false,
        value: `${ROUTES.SETTINGS}`,
        permission: [Permissions.WASTEMANAGE_SETTINGS],
      },
    ],
  },

  {
    icon: <FileMinus size={20} />,
    text: "Reports",
    value: `${ROUTES.REPORTS}`,
    hasChild: true,
    permission: [
      Permissions.REPORTS,
      Permissions.REPORTS_DAILYREPORT,
      Permissions.REPORTS_WORKDOCKET,
    ],
    children: [
      {
        text: "Daily Reports",
        value: `${ROUTES.DAILY_REPORTS}`,
        permission: [Permissions.REPORTS_DAILYREPORT],
      },
      {
        text: "Work Docket 2.0",
        active: false,
        value: "/work-docket",
        permission: [Permissions.REPORTS_WORKDOCKET],
      },
    ],
  },
  {
    icon: <Icons name='time-icon' size={20} />,
    text: "Time Tracking",
    value: `${ROUTES.TIME_TRACKING}`,
    hasChild: true,
    permission: [
      Permissions.TIMETRACKING,
      Permissions.TIMETRACKING_SUMMARY,
      Permissions.TIMETRACKING_TIMESHEET,
      Permissions.TIMETRACKING_SUBCONTRACTOR,
      Permissions.TIMETRACKING_WORKLOGS,
      Permissions.TIMETRACKING_SETTINGS,
    ],
    children: [
      {
        text: "Summary",
        active: false,
        value: `${ROUTES.SUMMARY}`,
        permission: [Permissions.TIMETRACKING_SUMMARY],
      },
      {
        text: "Employee",
        active: false,
        value: `${ROUTES.TIME_SHEET}`,
        permission: [Permissions.TIMETRACKING_TIMESHEET],
      },
      {
        text: "Sub-Contractor",
        active: false,
        value: `${ROUTES.SUB_CONTRACTOR}`,
        permission: [Permissions.TIMETRACKING_SUBCONTRACTOR],
      },
      {
        text: "Worklogs",
        active: false,
        value: `${ROUTES.WORK_LOG}`,
        permission: [Permissions.TIMETRACKING_WORKLOGS],
      },
      {
        text: "Settings",
        active: false,
        value: `${ROUTES.SETTINGS}`,
        permission: [Permissions.TIMETRACKING_SETTINGS],
      },
    ],
  },
  {
    icon: <Icons name='time-icon' size={20} />,
    text: "Payroll",
    value: `${ROUTES.PAYROLL}`,
    hasChild: true,
    permission: [Permissions.PAYROLL],
    children: [
      {
        text: "Case 2",
        active: false,
        value: `${ROUTES.CASE_2}`,
        permission: [Permissions.PAYROLL_CASE2],
      },
      {
        text: "Part 1",
        active: false,
        value: `${ROUTES.PART_1}`,
        permission: [Permissions.PAYROLL_PART1],
      },
    ],
  },
  {
    icon: <Icons size={20} name='ware-housing' />,
    text: "Warehousing",
    value: `${ROUTES.WARE_HOUSING}`,
    hasChild: false,
    permission: [Permissions.WAREHOUSE],
  },
  {
    icon: <Icons size={20} name='calendar' />,
    text: "Calendar",
    value: `${ROUTES.CALENDAR}`,
    hasChild: false,
    permission: [Permissions.CALENDAR],
  },
  {
    icon: <Icons size={20} name='support' />,
    text: "Support",
    value: `${ROUTES.SUPPORT}`,
    hasChild: false,
    permission: [Permissions.SUPPORT],
  },
  {
    icon: <Icons size={20} name='messages' />,
    text: "Message",
    value: `${ROUTES.MESSAGES}`,
    hasChild: false,
    permission: [Permissions.MESSAGES],
    // alert: true,
  },
  {
    icon: <Icons size={20} name='items' />,
    text: "Items",
    value: `${ROUTES.ITEMS}`,
    hasChild: false,
    permission: [Permissions.ITEMS],
  },
  {
    icon: <Icons size={20} name='template' />,
    text: "Template",
    value: `${ROUTES.TEMPLATE}`,
    hasChild: false,
    permission: [Permissions.TEMPLATE],
  },
  {
    icon: <Icons size={20} name='fleet' />,
    text: "Fleet Register",
    value: `${ROUTES.FLEET}`,
    hasChild: false,
    permission: [Permissions.FLEETS],
  },
  {
    icon: <Icons size={20} name='tools' />,
    text: "Tools",
    value: `${ROUTES.TOOLS}`,
    hasChild: true,
    permission: [Permissions.TOOLS],
    children: [
      {
        text: "Products",
        active: false,
        value: `${ROUTES.PRODUCTS}`,
        permission: [Permissions.TOOLS],
      },
      {
        text: "Request",
        active: false,
        value: `${ROUTES.REQUEST}`,
        permission: [Permissions.TOOLS],
      },
    ],
  },
  {
    icon: <Icons size={20} name='setting-icon' />,
    text: "Setting",
    value: `${ROUTES.SETTINGS}`,
    hasChild: false,
    permission: [Permissions.SETTING],
  },
];

export const otherSideBarData: TSidebarItem[] = [
  /**
   * permission need to be change inside analytics
   */

  {
    icon: <Icons size={22} name='document-parser' />,
    text: "Document Parser",
    value: `${ROUTES.DOCUMENT_PARSER}`,
    hasChild: false,
    permission: [Permissions.WASTEMANAGE],
  },
  {
    icon: <Icons size={22} name='trending-up' />,
    text: "Analytics",
    value: `${ROUTES.ANALYTICS}`,
    hasChild: true,
    permission: [Permissions.WASTEMANAGE],
    children: [
      {
        text: "Summary",
        active: false,
        value: `${ROUTES.SUMMARY}`,
        permission: [Permissions.WASTEMANAGE],
      },
    ],
  },
  {
    icon: <Icons size={20} name='dashboard' />,
    text: "Dashboard",
    value: `${ROUTES.DASHBOARD}`,
    hasChild: false,
    permission: [Permissions.ALL],
  },

  {
    icon: <Icons size={20} name='tasks' />,
    text: "Tasks",
    value: `${ROUTES.TASKS}`,
    hasChild: false,
    permission: [Permissions.TASKS],
  },

  {
    icon: <Icons size={20} name='ohs' />,
    text: "OH&S",
    value: `${ROUTES.OHS}`,
    hasChild: false,
    permission: [Permissions.OHS],
  },
  {
    icon: <Icons size={20} name='announcement' />,
    text: "Announcement",
    value: `${ROUTES.ANNOUNCEMENT}`,
    hasChild: false,
    permission: [Permissions.ANNOUNCEMENT],
  },
];

export const customerSidebarData: TSidebarItem[] = [
  {
    icon: <Icons size={20} name='dashboard' />,
    text: "Dashboard",
    value: `${ROUTES.DASHBOARD}`,
    hasChild: false,
    permission: [Permissions.CP_DASHBOARD],
  },

  {
    icon: <Calendar size={16} />,
    text: "User Management",
    value: `${ROUTES.USER_MANAGEMENT}`,
    hasChild: false,
    permission: [Permissions.CP_USERMANAGEMENT],
  },

  {
    icon: <Icons size={20} name='projects' />,
    text: "Projects",
    value: `${ROUTES.PROJECTS}`,
    hasChild: false,
    permission: [Permissions.CP_PROJECTS],
  },
  {
    icon: <FileMinus size={20} />,
    text: "Invoices",
    value: `${ROUTES.INVOICING}`,
    hasChild: false,
    permission: [Permissions.CP_INVOICES],
  },
  {
    icon: <Icons size={20} name='projects' />,
    text: "Work Docket",
    value: `${ROUTES.WORK_DOCKET}`,
    hasChild: false,
    permission: [Permissions.CP_WORKDOCKETS],
  },
  {
    icon: <Icons size={20} name='waste-manage' />,
    text: "Waste Management",
    value: `${ROUTES.WASTE}`,
    hasChild: false,
    permission: [Permissions.CP_WASTEMANAGEMENT],
  },
  {
    icon: <Package size={20} />,
    text: "Warehousing",
    value: `${ROUTES.WARE_HOUSING}`,
    hasChild: false,
    permission: [Permissions.CP_WAREHOUSING],
  },
  {
    icon: <Twitch size={20} />,
    text: "Support",
    value: `${ROUTES.SUPPORT}`,
    hasChild: false,
    permission: [Permissions.CP_SUPPORT],
  },
];
